var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-home-scene",class:{
        'c-home-scene--visible':
            _vm.isSceneReady && _vm.isExperienceStarted && _vm.homeModel && (!_vm.transitionOutUrl || _vm.transitionOutUrl === '/')
    }},[_c('canvas',{ref:"home_scene__container",staticClass:"c-home-scene__container"})])}
var staticRenderFns = []

export { render, staticRenderFns }